import {
  Component,
  computed,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
  Signal,
} from "@angular/core";
import { ButtonCtaComponent } from "@components/button-cta/button-cta.component";
import { CsIconModule } from "@components/icon";
import { Catalog } from "@cureskin/api-client/src/server-api";

@Component({
  selector: "app-product-jumbo",
  imports: [CsIconModule, ButtonCtaComponent],
  templateUrl: "./product-jumbo.component.html",
  styles: [
    `
      :host {
        display: flex;
        flex-direction: column;
        width: 152px;
        min-width: 152px;
      }
    `,
  ],
  standalone: true
})
export class ProductJumboComponent {
  product: InputSignal<Catalog> = input();
  productInCart: InputSignal<any> = input();
  gotoProduct: OutputEmitterRef<Catalog> = output();
  addToCart: OutputEmitterRef<{ product: Catalog; image: HTMLImageElement }> =
    output();
  reomveFromCart: OutputEmitterRef<Catalog> = output();

  productImage: Signal<string> = computed(
    () =>
      this.product()?.rebrandedImageWithBackground?.[0] ||
      this.product()?.productUnboxedImage?.[0] ||
      this.product()?.images?.[0] ||
      (this.product() as any)?.productImage
  );
  productTitle: Signal<string> = computed(() => this.product()?.title);

  productQuantity: Signal<number> = computed(() => {
    if (!this.productInCart()) return 0;

    // If productInCart is an object with quantity property
    if (
      typeof this.productInCart() === "object" &&
      this.productInCart()?.quantity !== undefined
    ) {
      return this.productInCart().quantity;
    }

    // If productInCart is just a number
    if (typeof this.productInCart() === "number") {
      return this.productInCart();
    }

    return 0;
  });

  addToCartAction(product: any, image: HTMLImageElement): void {
    this.addToCart.emit({ product, image });
  }

  removeFromCartAction(product: any): void {
    this.reomveFromCart.emit(product);
  }
}
